import { User } from 'src/components/types';
import { createAsyncAction } from 'src/redux/actions';

export const OptInToBeta = createAsyncAction('search/OPT_IN_TO_BETA');

export default (account: User | BB.Team) => {
  const { uuid: accountUuid } = account;
  if (!accountUuid) {
    return;
  }
  // eslint-disable-next-line consistent-return
  return {
    type: OptInToBeta.REQUEST,
    payload: {
      account,
    },
  };
};
